import { mapGetters } from "vuex";
import parsePhoneNumber from "libphonenumber-js";

export default {
  data() {
    return {
      REGEX_PHONE: /(\d{2})(\d{4})(\d{4})/,
      REGEX_MOBILE_PHONE: /(\d{2})(\d{5})(\d{4})/,
      MIN_LENGTH_PHONE: 5,
    };
  },

  computed: {
    ...mapGetters(["storeSettings"]),

    /**
     * Valida se a loja tem opção de envio nacional
     * @return {bool}
     */
    isNationalShipping() {
      return this.storeSettings.international_shipping == 0;
    },

    /**
     * Deve aplicar a mascara de telefone nacional se:
     *
     * 1 - A loja tem opção de envio nacional
     *
     * @return {bool}
     */
    isNationalNumber() {
      return (
        this.isNationalShipping
      );
    },
  },

  methods: {
    /**
     * Aplica a mascara no telefone
     * Principal função do mixin
     * @param {string} phoneNumberUnformatted
     * @return {string}
     */
    phoneMask(phoneNumberUnformatted) {
      const onlyNumbers = phoneNumberUnformatted.replace(/\D/g, "");

      if (this.isNationalNumber) {
        return this.nationalNumber(onlyNumbers);

      }
      return this.internationalNumber(onlyNumbers);
    },

    /**
     * Retorna o número internacional formatado
     * @param {string} onlyNumbers
     * @return {string}
     */
    internationalNumber(onlyNumbers) {
      if (onlyNumbers.length === 0) {
        return '';
      }

      if (onlyNumbers.length < this.MIN_LENGTH_PHONE) {
        return `+${onlyNumbers}`;
      }

      const phoneNumber = parsePhoneNumber(`+${onlyNumbers}`);
      return phoneNumber.formatInternational();
    },

    /**
     * Retorna o número nacional formatado
     * @param {string} onlyNumbers
     * @return {string}
     */
    nationalNumber(onlyNumbers) {
      if (onlyNumbers.length >= 12) {
        onlyNumbers = this.removeDDI(onlyNumbers);
      }

      const numberWithMask = onlyNumbers.replace(
        this.regexPhoneType(onlyNumbers),
        "($1) $2-$3"
      );

      return numberWithMask;
    },

    /**
     * Retorna o tipo de regex de acordo com o tamanho do número
     * @param {string} numberWithoutDDI
     * @return {string}
     */
    regexPhoneType(numberWithoutDDI) {
      return numberWithoutDDI.length > 10
        ? this.REGEX_MOBILE_PHONE
        : this.REGEX_PHONE;
    },

    /**
     * Remove o DDI +55 do número quando ele está presente.
     *
     * O DDI só é removido quando o comprimento indica número brasileiro com DDI:
     * - 12 dígitos: DDI (55) + DDD (2) + fixo (8)
     * - 13 dígitos: DDI (55) + DDD (2) + celular (9)
     *
     * Números com 10 ou 11 dígitos são nacionais e NÃO devem ser alterados,
     * inclusive celulares com DDD 55 (Rio Grande do Sul) que possuem 11 dígitos
     * e começam com "55" mas não carregam DDI.
     *
     * @param {string} number - Somente dígitos
     * @return {string}
     */
    removeDDI(number) {
      const isCellphoneWithDDI = number.length === 13 && number.startsWith("55");
      const isLandlineWithDDI = number.length === 12 && number.startsWith("55");

      if (isCellphoneWithDDI || isLandlineWithDDI) {
        return number.substring(2);
      }

      return number;
    },
  },
};
